import type React from 'react';

import { useTheme } from '@mui/material/styles';
import type { ExtendedCustomDotProps } from '@/components/phasesCurve/interfaces.ts';

import { phaseTypeColorConfig } from '../phaseCurve.config.ts';

export const CustomDot = (props: ExtendedCustomDotProps): React.ReactElement => {
  const { cx, cy, payload, disabled, radius, inverted, sw } = props;
  const theme = useTheme();
  const color1 = disabled ? theme.customPalette.objects.disabled : phaseTypeColorConfig[payload.type].color;
  const color2 = 'white';
  return (
    <circle
      data-testid={`${payload.type} phase: ${payload.phase.toString()}%`}
      cursor={'pointer'}
      cx={cx}
      cy={cy}
      r={radius}
      fill={inverted ? color1 : color2}
      stroke={inverted ? color2 : color1}
      strokeWidth={sw ?? 1}
    />
  );
};
